import _LabelInputBase from '../_LabelInputBase/_LabelInputBase';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './RadioGroup.html?raw';
import on from 'dojo/on';
import docu from './RadioGroupDocumentation.html?raw';
import lang from 'dojo/_base/lang';
import CheckBox from '../CheckBox/CheckBox';
import { EntityHelpers } from "../../../more/Helpers";
import _InputMultiBase from '../_InputMultiBase/_InputMultiBase';


interface ValueEntry {
    value: any;
    label: string;
    entity?: any;
    bgColor?: string;
    option?: Option;
    enabled?: boolean;
    selected?: boolean;
}

interface Option {
    inputNode?: HTMLElement;
    input: MdsLax<InstanceType<typeof CheckBox>>;
    labelNode?: HTMLElement;
    valueSource: ValueEntry
}

interface radioGroup_customInputStyleConfig {
    borderColorDefault?: string,
    colorSelected?: string
}

type alignment = "horizontal" | "horizontalRight" | "vertical" | "verticalRight";

class RadioGroup extends compose(_LabelInputBase, _InputMultiBase) {
    templateString: any = template;

    private itemContainer: HTMLElement;
    protected alignment: alignment = "vertical";
    private iconAlignment: "left" | "right";
    private paddings: "default" | "bigger";

    protected _manualHighlightOverride: boolean = false;

    presetValue: any = undefined; 

    private valueList: Array<ValueEntry> = [];
    private optionsRegistry: Array<Option> = null;// [];
    private _selectedValues: Array<any> = [];
    private _selectedEntities: Array<object> = [];

    labelAttribute: string = null;
    valueAttribute: string = "ID"; // Vorgabewert
    colorAttribute: string = null; // Vorgabewert
    selectableAttribute: string = null; // Vorgabewert
    suggestionLabelAttribute: string = null;
    addNonExistentOption: boolean = true;



    
    // Cusom Styling props --------------end

    //events

    private _onChange_Input(option: Option): void {
        if (!option) return;
       
        this.selectOption(option, option.input.getValue());
    }

    private _onClick_InputContainer(option: Option): void {
        if (!option) return;
        if (option.valueSource.enabled === false) return;
        this.selectOption(option, option.input.getValue() !== true);
    }


    
    // Cusom Styling methods --------------------------------------------------------END
    // BUILD inputs----------------------------------------------------------------------------START

    constructor(config: { entries: ValueEntry[], alignment?: alignment, orientation?: alignment, value?: any, paddings?: "default" | "bigger" }) {
        super(...(arguments as unknown as []));
        if (!config) return;

        if (config.orientation) {
            config.alignment = config.orientation;
        }
        if (config.alignment) {
            this.setAlignment(config.alignment);
        }

        this.valueList = config.entries;
        if (typeof (config.value) != "undefined") {
            this.presetValue = config.value;
        }

        if (config.paddings) {
            this.paddings = config.paddings;
        }
    }

    private _constructOptions(): void {

        this.optionsRegistry = [];
        this.UiModder.domConstruct.empty(this.itemContainer);


        for (let entry of this.valueList) {
            let option = this._createOption(entry);
            this.optionsRegistry.push(option);
            option.valueSource = entry;
            entry.option = option;
        }

        this.UiModder.domClass.toggle(this.itemContainer, "horizontal", this.alignment == "horizontal");
        this.UiModder.domClass.toggle(this.itemContainer, "rightAlign", this.iconAlignment == "right");

        this._applyChildCyNames();
    }

    private _applyChildCyNames(): void {
        if (!this._cyName || !this.optionsRegistry) return;
        for (let option of this.optionsRegistry) {
            const key = option.valueSource?.value ?? option.valueSource?.label ?? "";
            option.input.setCyName([this._cyName, key].filter(Boolean).join(":"));
        }
    }

    public setAllDataCyAttributes() {
        this._applyChildCyNames();
    }


    private _createOption(entry: ValueEntry):Option {

        let singleInputContainer = this.UiModder.domConstruct.create("div", {
            className: "inputContainer item",
            "data-value":entry.value
        }, this.itemContainer);

        let option: Option = {
            input: null,
            valueSource: entry
        };



        let radioButton = new CheckBox();
        radioButton.setType("radio");
        radioButton.setLabel(entry.label);

        if (this.iconAlignment == "right") {
            radioButton.setAlignment("iconright");
        }

        if (entry.bgColor) {
            radioButton.setColor(entry.bgColor, null);
        }

        radioButton.setReadonly(entry.enabled === false);
        //if (entry.enabled !== false) {
        //    this.UiModder.domClass.add(singleInputContainer, "hoverAuto");
        //    on(singleInputContainer, "click", lang.hitch(this, this._onClick_InputContainer, option));

        //}
        //if (this._value) {
        //    this.selectOption(option, entry.preselected, true);
        //}

        radioButton.placeAt(singleInputContainer);

        on(radioButton, "change", lang.hitch(this, this._onChange_Input, option));

        option.input = radioButton;

        option.input.setChecked(entry.selected, true);



        return option;
    }

    private getIndexOfValue(value: any): number {
        for (let i = 0; i < this._selectedValues.length; i++) {
            if (this._selectedValues[i] == value) return i;
        }
        return -1;
    }

    selectOptionByName(value: string, bSelect: boolean = true, bSuppressChange?: boolean): void {
        let opt = this.getOptionByValue(value);
        if (opt) {
            this.selectOption(opt, bSelect, bSuppressChange);
            //opt.input.setChecked(bool, bSuppressChange);
        }
    }

    private selectOption(option: Option, bSelect: boolean = true, suppressChange?: boolean) {

        let entry = option ? option.valueSource : null;

        if (!entry) return;

        if (entry.enabled === false) return;


        if (!this.isMultiSelect) {
            let oldValue = this.getValue();
            if (typeof (oldValue) != "undefined") {
                let oldOption = this.getOptionByValue(oldValue);
                
                if (oldOption) {
                    oldOption.valueSource.selected = false;
                    oldOption.input.setValue(false, true);
                    oldOption.input.setNonInteractive(false);
                    let index = this.getIndexOfValue(oldValue);
                    if (index != -1) {
                        this._selectedValues.splice(index);
                        this._selectedEntities.splice(index);
                    }
                }
            }
        }


        let index = this.getIndexOfValue(entry.value);
        if (index != -1) {
            this._selectedValues.splice(index);
            this._selectedEntities.splice(index);
        }

        if (bSelect == true) {
            this._selectedEntities.push(entry.entity);
            this._selectedValues.push(entry.value);

            entry.selected = true;
        }

        this._value = this._selectedValues;

        this.validateInput();

        if (suppressChange !== true) {
            this.__delayValueChangeEmit();
        }
        if (option) {
            option.input.setValue(bSelect == true, true);
        }


        // bei Einzelauswahl mit Pflichtfeld das Input danach sperren, gegen Abwahl:
        if (this.isMandatory && !this.isMultiSelect) {
            option.input.setNonInteractive((option.input.getValue() == true));
        }

    }

    protected customValidation(): boolean {
        if (this.isMandatory) {
            if (!this._selectedValues.length) return false;
        }

        return true;
    }

    setReadonly(bReadOnly: boolean ) {
        super.setReadonly.apply(this, arguments as any);


        if (this.optionsRegistry) {
            for (var option of this.optionsRegistry) {

                option.input.setReadonly(bReadOnly);
            }
        }
    }


    getOptionByValue(value: any): Option {
        if (this.valueList) {
            for (let entry of this.valueList) {
                if (entry.value == value) {
                    return entry.option;
                }
            }
        }
        return null;
    }

    // build inputs -----------------------------------------------------------------------END
    setData(presetValue: any,
        valuelist: Array<Object>,
        bSuppressChange?: boolean,
        labelAttribute?: string,
        valueAttribute?: string,
        colorAttribute?: string): void {

        if (labelAttribute) this.labelAttribute = labelAttribute;
        if (valueAttribute) this.valueAttribute = valueAttribute;
        if (colorAttribute) this.colorAttribute = colorAttribute;
       

        if (!lang.isArray(valuelist)) {
            valuelist = [];
        }



        let values = [];
        let labels = [];
        let selectables = [];
        let selected = [];
        let colors = [];
        let entities = [];

        let groupLabels = [];
        let groupValues = [];
        let groupColors = [];
        let groupIcons = [];

        for (let unknown of valuelist) {
            let color = null;
            let value = null;
            let label = null;

            let selectable: boolean = true;

            let groupLabel = null;
            let groupValue = null;
            let groupColorBg = null;

            if (typeof (unknown) == "object" && !!unknown) {
                value = EntityHelpers.getComplexProperty(unknown, this.valueAttribute);

                label = EntityHelpers.getComplexProperty(unknown, this.labelAttribute);
                if (!label) label = value;

               

                color = null;
                if (this.colorAttribute) {
                    if (unknown.hasOwnProperty(this.colorAttribute)) {
                        let colorValue = unknown[this.colorAttribute] as more.EntityAPIColor & Object | string;
                        if (colorValue) {
                            if (typeof (colorValue) == "string") {
                                color = colorValue;
                            } else if (colorValue.hasOwnProperty("pitBGR")) {
                                color = colorValue;
                            }
                        }
                    } else {
                        let colorValue = EntityHelpers.getComplexProperty(unknown, this.colorAttribute);
                        if (colorValue) {
                            if (typeof (colorValue) == "string") {
                                color = colorValue;
                            } else if (colorValue.hasOwnProperty("pitBGR")) {
                                color = colorValue;
                            }
                        }
                    }
                }

                selectable = true;
                if (this.selectableAttribute) {
                    selectable = EntityHelpers.getComplexProperty(unknown, this.selectableAttribute) !== false;
                }

                entities.push(unknown);

            } else if (typeof (unknown) == "string") {
                // ??? was sollma damit
                value = unknown;
                label = unknown;
                entities.push(null);
            }

            groupLabels.push(groupLabel);
            groupValues.push(groupValue);
            groupColors.push(groupColorBg);

            colors.push(color);
            values.push(value);
            labels.push(label);
            selectables.push(selectable);
        }
        this.setOptionsWithColor(values, labels, colors, presetValue, selectables, entities, bSuppressChange);

    }
    setOptionsWithColor(values: Array<any>,
        labels: Array<string>,
        colors: Array<string | Partial<more.EntityAPIColor>>,
        presetValue?: Array<any> | any,
        selectable?: Array<boolean>,
        entityData?: Array<any>,
        bSuppressChange?: boolean) {

        this.valueList = [];

        //this._isInitialized = true;
        //this._initialValue = undefined;

        let unknownPresetCopy = null;
        if (presetValue) unknownPresetCopy = lang.clone(presetValue);


        //console.debug("multiselect setoptions", values, labels, preselected, selectable);
        if (typeof (unknownPresetCopy) != "undefined") {
            this._selectedEntities = [];
            this._selectedValues = [];
        }
        if (!lang.isArray(unknownPresetCopy)) {
            let preselectedAsObject = unknownPresetCopy as Object;
            if (typeof (unknownPresetCopy) == "string") {
                unknownPresetCopy = [unknownPresetCopy];
            }
            // es ist ein einzelnes Objekt:
            else if (unknownPresetCopy && typeof (unknownPresetCopy) == "object") {

                let value = EntityHelpers.getComplexProperty(unknownPresetCopy, this.valueAttribute);
                // ganzes Entity übergeben. nur value rausziehen:
                unknownPresetCopy = value;

            } else {
                unknownPresetCopy = [];
            }
        }

        let preselectedValues: Array<boolean> = [];

        // testen ob im Array booleans stehen oder gewählte Werte
        if (unknownPresetCopy.length > 0) {

            let testValue = unknownPresetCopy[0];

            // Variante 1: es ist ein Array mit den bool-Werten, das synchron zu den übergebenen values behandelt wird
            if (typeof (testValue) == "boolean") {
                for (let i = 0; i < unknownPresetCopy.length && i < values.length; i++) {
                    // tatsächlich selektierte Werte schon mal vormerken:
                    if (unknownPresetCopy[i] == true) {
                        this._selectedValues.push(values[i]);
                    }
                }
            }

            // Variante 2: es ist ein Array mit gewählten Werten.
            // ein neues Array aufbauen, das gleich lang ist wie die values und vergleichen was selektiert ist:
            if (typeof (testValue) == "string") {
                // neues Array erstellen das booleans enthält
                let newPreselected: Array<boolean> = [];
                for (var i = 0; i < values.length; i++) {
                    let val: string = values[i];
                    let bIsSelected = unknownPresetCopy.indexOf(val, 0) != -1;
                    newPreselected.push(bIsSelected);

                    // tatsächlich selektierte Werte schon mal vormerken:
                    if (bIsSelected) this._selectedValues.push(val);

                }

                preselectedValues = newPreselected;
            }
        }


        if (!lang.isArray(selectable)) {
            selectable = [];
        }

        if (!lang.isArray(entityData)) {
            entityData = [];
        }

        let bgColors: Array<string> = [];
        if (!lang.isArray(colors)) {
            colors = [];
        }

        for (let colValue of colors) {
            if (colValue) {
                if (typeof (colValue) == "string") {
                    // hexcolor!
                    bgColors.push(colValue);
                } else if ((colValue as more.EntityAPIColor & Object).hasOwnProperty("BackColor")) {
                    bgColors.push(colValue.BackColor?.Hex ? colValue.BackColor.Hex : null);
                }
            } else {
                bgColors.push(null);
            }
        }

        for (var i = 0; i < values.length; i++) {
            var val: any = values[i];
            var lbl: string = labels[i];
            var preselect: boolean = false;
            var enabled: boolean = true;
            let color: string = null;
            let entity = null;


            if (preselectedValues.length > i) {
                preselect = preselectedValues[i];
            }

            if (selectable.length > i) {
                enabled = selectable[i] === true;
            }

            if (bgColors.length > i) {
                color = bgColors[i];
            }
            if (entityData.length > i) {
                entity = entityData[i];
            }

            //if (groupLabels.length > i) {
            //    group = groupLabels[i];
            //}

            this._addSelectableValue(val, lbl, preselect, enabled, entity, color);
        }

        //this._useGrouping = groupLabels?.length == this.valueList?.length && !!this.valueList.length;

        //this.handleNonExistentValues(presetValue, false);

        this._constructOptions();

        //console.debug("multiselect valuelist", this.valueList);

        this.validateInput();
    }

    private _addSelectableValue(value: any, label: string, selected?: boolean, enabled?: boolean, entity?: any, bgColorHex?: string) {

        let descriptor: ValueEntry = {
            bgColor: bgColorHex ? bgColorHex : null,
            entity: entity ? entity : null,
            label: label,
            enabled: enabled === false ? false : true,
            selected: selected === true ? true : false,
            value: value
        };


        this.valueList.push(descriptor);

        if (selected === true && this._selectedValues?.indexOf(value) == -1) {
            this._selectedValues.push(value);
        }
    }


    getValue(mode: "value" | "entity" | "label" = "value"): any | any[] {
        // set asLabel to true to get the value as label


        if (!mode || mode == "value") {
            if (this.isMultiSelect) {
                return this._value ? this._value : null;
            }
            return this._selectedValues?.length ? this._selectedValues[0] : null;
        }


        if (mode == "entity") {
            if (this.isMultiSelect) {
                return this._selectedEntities;
            }

            return this._selectedEntities?.length ? this._selectedEntities[0] : null;
        }

        let returnValues = [];

        for (let val of this._selectedValues) {

            let option = this.getOptionByValue(val);
            if (option) {
                returnValues.push(option.valueSource.label);
            }
        }

        if (this.isMultiSelect) {
            return returnValues;
        }

        return returnValues?.length ? returnValues[0] : null;
    }

    
    addEntry(value: any, label: string, enabled: boolean = true, color?: string): void {
        // Add one more choice option and re-render the radioBox 

        if (typeof(value) != "undefined" && label) {

            this.valueList.push({
                label: label,
                value: value,
                enabled: enabled,
                bgColor: color,
            });
            this.itemContainer.innerHTML = null;
            this._constructOptions();

        } else {
            this.emit("no value");
        }

    }
       
    removeEntry(value?: any, label?: string): void {
         // Remove a value from choice options and re-render the radioBox 

        /// todo... braucht ja eigentlich so gut wie nie wer. ansonsten muss es auch im Multiselect etc überall nachgezogen werden
    }
   
  

    protected _setReadonlyStyle(): void {

       
    }


    setValue(newValue: any, suppressChangeEvent: boolean = false): void {
        if (lang.isArray(newValue)) {
            // TODO
        } else if (typeof (newValue) != "undefined") {
            let option = this.getOptionByValue(newValue);
            if (option) {
                this.selectOption(option, true, suppressChangeEvent);
                //this._value = newValue;
            } else {
                this.presetValue = newValue;
            }
        } else {
            let option = this.getOptionByValue(this._value);
            if (option) {
                this.selectOption(option, false, suppressChangeEvent);
            }

            this._value = null;
        }
        

    }

  
    setAlignment(value: alignment): void {
        this.alignment = value
    
        // change alignment and re-render the radiogroup
        this.iconAlignment = "left";

        if (this.alignment == "verticalRight") {
            this.iconAlignment = "right";
            this.alignment = "vertical";
        }
        if (this.alignment == "horizontalRight") {
            this.iconAlignment = "right";
            this.alignment = "horizontal";
        } 

        if (/^hor/i.test(this.alignment)) {
            this.alignment = "horizontal"
        } else {
            this.alignment = "vertical"
        }


        if (this.valueList?.length && this.optionsRegistry?.length) {
            this._constructOptions();
        }
    }

    setPaddings(style: "default" | "bigger") {
        this.UiModder.domClass.remove(this.domNode, this.paddings + "Paddings");

        switch (style) {
            
            default:
                this.paddings = "default";
                break;

            case "bigger":
            case "default":
                this.paddings = style;
        }

        this.UiModder.domClass.add(this.domNode, this.paddings + "Paddings");
    }
   
    // Validation --------------------------------------------------

    // Doku
    getDocumentationContent(): string {
        return docu;
    }

    // DOJO -------------------------------------------------------------------

    private _setPaddingsAttr(style: string): void {
        this.setPaddings(style as any);
    }

    private _setEntriesAttr(entries: ValueEntry[]): void {
        this.valueList = entries;
    }

    private _setAlignmentAttr(value: alignment): void {
        this.setAlignment(value);
    }

    private _setPresetValueAttr(value: any): void {
        this.presetValue = value;
    }

    destroy(): void {

        if (this._destroyed) return;
        super.destroy.apply(this, arguments as any);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        if (this.valueList?.length) {
            this._constructOptions();
        } else {
            this.valueList = [];
        }

        this.setPaddings(this.paddings);

        if (typeof (this.presetValue) != "undefined") {
            this.setValue(this.presetValue, true);
        }

    }

    startup(): void {
        super.startup.apply(this, arguments as any);

    }

    
}

export default mdsWidget(RadioGroup);